export default __webpack_public_path__ + "static/media/1008.b04557a3.png";